module.exports = __webpack_public_path__ + "img/DAVID_CANNON_47-rs.be3807c4.jpg";